import {CsvTableViewer, MarkdownViewer} from '@dv5/components'
import {DocumentWidgetData, PartType} from '@dv5/domain'
import {FC} from 'react'
import {useWidgetEditor} from '../../hooks/useWidgetEditor'
import {OnNavigateToDocument, WidgetProps} from '../../model/WidgetProps'
import {widgetService} from '../../services/widgetService'
import {WidgetFrame} from '../common/WidgetFrame'
import {DocumentWidgetToolbar} from './DocumentWidgetToolbar'
import './DocumentWidget.less'

type Props = WidgetProps & { onNavigateToDocument: OnNavigateToDocument }

export const DocumentWidget: FC<Props> = ({
                                              canvasId,
                                              widget,
                                              selected,
                                              settings,
                                              editingWidgetId,
                                              onStartDrag,
                                              onStartResize,
                                              onContextMenu,
                                              dragState,
                                              onStartLinkCreation,
                                              onCompleteLinkCreation,
                                              onNavigate,
                                              onDeleteDataLink,
                                              onNavigateToDocument,
                                          }) => {
    const data = widget.data as DocumentWidgetData
    const {containerRef, resizeCursor, handlers, renderResizeHandles, renderLinkDots} = useWidgetEditor({
        widget, selected, editingWidgetId, dragState, onStartDrag, onStartResize, onContextMenu,
        onStartLinkCreation, onCompleteLinkCreation, onNavigate, onDeleteDataLink,
    })
    const parts = widget.documentParts?.slice().sort((a, b) => a.partIndex - b.partIndex)
    const broken = widget.targetAvailable === false || (widget.targetAvailable == null && !parts)
    return <>
        {selected && <DocumentWidgetToolbar
            data={data}
            targetAvailable={!broken}
            toolbarStyles={widgetService.getCenteredToolbarStyle(widget)}
            onNavigateToDocument={onNavigateToDocument}
        />}
        <WidgetFrame
            baseClass='documentWidget'
            canvasId={canvasId}
            widget={widget}
            settings={settings}
            selected={selected}
            editingWidgetId={editingWidgetId}
            resizeCursor={resizeCursor}
            handlers={handlers}
            containerRef={containerRef}
            renderResizeHandles={renderResizeHandles}
            renderLinkDots={renderLinkDots}
            onNavigate={onNavigate}
            onDeleteDataLink={onDeleteDataLink}
            showTypeIconOnHover
        >
            <div className="documentWidget-content">
                <strong>{data.title || 'Document'}</strong>
                {broken && <p className="documentWidget-brokenLink" role="status">Broken link</p>}
                {!broken && parts?.length === 0 && <p>No parts.</p>}
                {!broken && parts?.map(part => <section key={part.id}>
                    {part.partHeader && <h4>{part.partHeader}</h4>}
                    {part.partType === PartType.MARKDOWN &&
                        <MarkdownViewer sourceCode={part.partContent} compactMode={true} onToggleCheckBox={() => {
                        }}/>}
                    {part.partType === PartType.CSV_TABLE &&
                        <CsvTableViewer sourceCode={part.partContent} editable={false} onChange={() => {
                        }}/>}
                    {part.partType === PartType.SECRET && <p>••••••</p>}
                    {part.partType !== PartType.MARKDOWN && part.partType !== PartType.CSV_TABLE && part.partType !== PartType.SECRET &&
                        <pre>{part.partContent}</pre>}
                </section>)}
            </div>
        </WidgetFrame>
    </>
}
